import { PIN_REQUEST } from '@/utils/consts'

export default {
  password: '',
  type: PIN_REQUEST.PASSWORD_CHANGE,
  closedSessions: {}
}
